module.exports = __webpack_public_path__ + "static/img/paohuzi.3460e85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/paohuzi.jpg
// module id = t1li
// module chunks = 0